/* eslint-disable complexity */
import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import {
    STBarGrouping,
    STDLblPos,
    SubChartType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';

import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import type { BarChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/bar-chart';


export function getAvailableDataLabelPositions(chartType?: PresetChartType): STDLblPos[] {
    switch (chartType) {
        case PresetChartType.COLUMN_CLUSTERED:
        case PresetChartType.BAR_CLUSTERED:
            return [
                STDLblPos.ctr,
                STDLblPos.inEnd,
                STDLblPos.inBase,
                STDLblPos.outEnd,
            ];
        case PresetChartType.COLUMN_STACKED:
        case PresetChartType.COLUMN_PERCENT_STACKED:
        case PresetChartType.BAR_STACKED:
        case PresetChartType.BAR_PERCENT_STACKED:
            return [
                STDLblPos.ctr,
                STDLblPos.inEnd,
                STDLblPos.inBase,
            ];
        case PresetChartType.LINE_STANDARD:
        case PresetChartType.LINE_STACKED:
        case PresetChartType.LINE_PERCENT_STACKED:
        case PresetChartType.LINE_STANDARD_WITH_POINT:
        case PresetChartType.LINE_STACKED_WITH_POINT:
        case PresetChartType.LINE_PERCENT_STACKED_WITH_POINT:
        case PresetChartType.SCATTER:
        case PresetChartType.SCATTER_WITH_STRAIGHTLINE:
        case PresetChartType.SCATTER_WITH_STRAIGHTLINE_ADN_MARKER:
        case PresetChartType.SCATTER_WITH_SMOOTHLINE:
        case PresetChartType.SCATTER_WITH_SMOOTHLINE_ADN_MARKER:
        case PresetChartType.BUBBLE:
            return [
                STDLblPos.ctr,
                STDLblPos.l,
                STDLblPos.r,
                STDLblPos.t,
                STDLblPos.b,
            ];
        case PresetChartType.PIE:
        case PresetChartType.OF_PIE:
        case PresetChartType.OF_PIE_BAR:
            return [
                STDLblPos.ctr,
                STDLblPos.inEnd,
                STDLblPos.outEnd,
                STDLblPos.bestFit,
            ];
        case PresetChartType.DOUGHNUT:
        case PresetChartType.RADAR:
        case PresetChartType.RADAR_WITH_POINT:
        case PresetChartType.RADAR_WITH_FILL:
        case PresetChartType.AREA:
        case PresetChartType.AREA_STACKED:
        case PresetChartType.AREA_PERCENT_STACKED:
            return [];
        default:
            return [];
    }
}

export function getDataLabelDefaultPosition(model: IChartModel, seriesId?: string): STDLblPos | undefined {
    const currentSubChart = seriesId
        ? model.plotArea.charts.find(chart => chart.series.find(seriesItem => seriesItem.seriesId === seriesId))
        : model.plotArea.charts[0];
    if (!currentSubChart) return STDLblPos.bestFit;
    const { type } = currentSubChart;
    switch (type) {
        case SubChartType.BarChart:
        case SubChartType.Bar3DChart: {
            const { grouping } = currentSubChart as BarChart;
            if (grouping === STBarGrouping.stacked || grouping === STBarGrouping.percentStacked) {
                return STDLblPos.ctr;
            }
            return STDLblPos.outEnd;
        }
        case SubChartType.LineChart:
        case SubChartType.Line3DChart:
            return STDLblPos.r;
        case SubChartType.RadarChart:
            return;
        case SubChartType.PieChart:
        case SubChartType.Pie3DChart:
            return STDLblPos.bestFit;
        case SubChartType.DoughnutChart:
            return;
        case SubChartType.Area3DChart:
        case SubChartType.AreaChart:
            return;
        case SubChartType.ScatterChart:
            return STDLblPos.t;
        case SubChartType.BubbleChart:
            return STDLblPos.r;
        case SubChartType.StockChart:
            return STDLblPos.outEnd;
        case SubChartType.OfPieChart:
            return STDLblPos.bestFit;
    }
}
